import { Helmet } from 'react-helmet-async';

const StructuredData = () => {
  const restaurantSchema = {
    "@context": "https://schema.org",
    "@type": "Restaurant",
    "name": "Fleur de Sel",
    "image": [
      "https://fleurdeselrestaurant.lu/img/inicio/3.jpg",
      "https://fleurdeselrestaurant.lu/img/logo3.png"
    ],
    "description": "Restaurant Fleur de Sel à Luxembourg. Cuisine portugaise authentique, fruits de mer frais et rodizio brésilien. Situé au 25 Rue Joseph Junck, près de la Gare de Luxembourg.",
    "@id": "https://fleurdeselrestaurant.lu",
    "url": "https://fleurdeselrestaurant.lu",
    "telephone": "+35228371979",
    "email": "reservations@fleurdeselrestaurant.lu",
    "priceRange": "€€-€€€",
    "servesCuisine": ["Portuguese", "Seafood", "Brazilian Rodizio", "European"],
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "25, Rue Joseph Junck",
      "addressLocality": "Luxembourg",
      "postalCode": "L-1839",
      "addressCountry": "LU"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": 49.60068290934538,
      "longitude": 6.131038237594128
    },
    "openingHoursSpecification": [
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
        "opens": "11:30",
        "closes": "15:00"
      },
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
        "opens": "18:30",
        "closes": "23:00"
      }
    ],
    "acceptsReservations": "True",
    "menu": "https://fleurdeselrestaurant.lu/menu",
    "hasMenu": {
      "@type": "Menu",
      "url": "https://fleurdeselrestaurant.lu/menu"
    },
    "sameAs": [
      "https://www.facebook.com/profile.php?id=100063786393603"
    ]
  };

  const localBusinessSchema = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "name": "Fleur de Sel",
    "image": "https://fleurdeselrestaurant.lu/img/logo3.png",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "25, Rue Joseph Junck",
      "addressLocality": "Luxembourg",
      "postalCode": "L-1839",
      "addressCountry": "LU"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": 49.60068290934538,
      "longitude": 6.131038237594128
    },
    "url": "https://fleurdeselrestaurant.lu",
    "telephone": "+35228371979",
    "openingHoursSpecification": [
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
        "opens": "11:30",
        "closes": "15:00"
      },
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
        "opens": "18:30",
        "closes": "23:00"
      }
    ]
  };

  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "Fleur de Sel",
    "url": "https://fleurdeselrestaurant.lu",
    "logo": "https://fleurdeselrestaurant.lu/img/logo3.png",
    "contactPoint": {
      "@type": "ContactPoint",
      "telephone": "+35228371979",
      "contactType": "reservations",
      "email": "reservations@fleurdeselrestaurant.lu",
      "availableLanguage": ["French", "English", "Portuguese"]
    },
    "sameAs": [
      "https://www.facebook.com/profile.php?id=100063786393603"
    ]
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(restaurantSchema)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(localBusinessSchema)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(organizationSchema)}
      </script>
    </Helmet>
  );
};

export default StructuredData;
